import Tablas from '../../../Componentes/Tablas'
import { Button,IconButton, Icon } from '@material-ui/core'
import { useRegistroFacturas } from './RegistroFacturasProvider'

const RegistroFacturasLista = () => {

    const {listaFacturas,setOpenModal} = useRegistroFacturas() 

    const abrir = ()=> setOpenModal(true);

    const columns =[{
        field:"id_empresa_factura",
        headerName:"ID",
    },
    {
        field:"propietario_empresa",
        headerName:"Propietario",
    },
    {
        field:"timbrado_factura",
        headerName:"Timbrado",
    },
    {
        field:"inicio_timbrado",
        headerName:"Fecha Inicio",
    },
    {
        field:"fin_timbrado",
        headerName:"Fecha fin",
    },
    {
        field:"nro_datos_factura",
        headerName:"Nros de factura",
    },
    {
        field:"nro_inicio_factura",
        headerName:"Nro inicio factura",
    },
    {
        field:"nro_fin_factura",
        headerName:"Nro fin factura",
    },
    {
        field:"nombre_caja",
        headerName:"Caja asignada"
    }
]


    
    const Acciones = ()=>(<div>
        <IconButton>
            <Icon>delete</Icon>
        </IconButton>
    </div>)

    const search = (
        <Button variant="outlined" color="primary" onClick={abrir} >  
            Registrar
        </Button>
    )

  return (
    <>
      <Tablas 
        nombretabla="Facturas"
        icono="text_snippet"
        bgicono="#303f9f"
        subtitle="Facturas habilitadas por la set"
        columnas={columns}
        filas={listaFacturas}
        namecolumnID="id_empresa_factura"
        Acciones={Acciones}
        search={search}
      />
    </>
  )
}

export default RegistroFacturasLista
